<template>
  <div>
    <v-card class="login-card elevation-8 mb-4 login-card-ajuste mt-5 mx-auto">
      <div class="card-header">
        <div class="header-icon">
          <v-icon size="32" color="white">mdi-cellphone-key</v-icon>
        </div>
        <h2 class="header-title">
          Solicitar Token Mobile
          <small>(Somente Servidores da Educação Municipal)</small>
        </h2>
      </div>
      <v-card-text class="pa-6">
        <!-- ETAPA 1: Solicitar token pelo CPF -->
        <template v-if="etapa === 1">
          <p class="text-body-2 grey--text text--darken-1 mb-4 text-justify">
            Informe seu CPF para receber a chave de acesso no seu e-mail.
          </p>
          <small>CPF</small>
          <v-text-field
            v-model="cpf"
            required
            outlined
            prepend-inner-icon="mdi-card-account-details"
            maxlength="14"
            placeholder="000.000.000-00"
            @input="formatarCpf"
          />
          <v-alert v-if="msg" :type="msgType" class="mt-2 mb-4" dense>{{ msg }}</v-alert>
          <v-btn @click="solicitarToken" color="primary" class="validate-btn elevation-4 mt-2" block large>
            <v-icon left>mdi-email-send</v-icon>
            Enviar Chave por E-mail
          </v-btn>
          <v-btn
            @click="irParaEtapa2"
            color="orange darken-2"
            outlined
            class="validate-btn elevation-2 mt-3"
            block
            large
          >
            <v-icon left>mdi-key</v-icon>
            Já tenho a chave
          </v-btn>
        </template>

        <!-- ETAPA 2: Validar CPF + chave recebida por email -->
        <template v-else-if="etapa === 2">
          <v-alert type="success" dense class="mb-4">
            {{ msgEmail }}
          </v-alert>
          <small>CPF</small>
          <v-text-field v-model="cpf" outlined prepend-inner-icon="mdi-card-account-details" maxlength="14" readonly />
          <small>Chave recebida no e-mail</small>
          <v-text-field
            v-model="chave"
            required
            outlined
            prepend-inner-icon="mdi-key"
            placeholder="Cole a chave aqui"
            maxlength="100"
          />
          <v-alert v-if="msg" :type="msgType" class="mt-2 mb-4" dense>{{ msg }}</v-alert>
          <v-btn @click="validarChave" color="success" class="validate-btn elevation-4 mt-2" block large>
            <v-icon left>mdi-login</v-icon>
            Entrar
          </v-btn>
          <v-btn @click="voltarEtapa1" color="grey" text class="mt-2" block>
            <v-icon left small>mdi-refresh</v-icon>
            Solicitar nova chave
          </v-btn>
        </template>

        <div class="mt-3 text-center">
          <a href="#" @click.prevent="$emit('voltar')" class="voltar-link">
            <v-icon small color="#d84315">mdi-arrow-left</v-icon>
            Voltar para o login
          </a>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center">
          <v-progress-circular indeterminate color="white" size="40" class="mb-4" />
          <span>Aguarde...</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CredenciamentoServices from "@/services/acesso/CredenciamentoServices";
import filters from "@/libs/filters";

export default {
  name: "SolicitarTokenMobile",
  data: () => ({
    etapa: 1,
    cpf: "",
    chave: "",
    msg: "",
    msgType: "info",
    msgEmail: "",
    loading: false,
  }),
  mounted() {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload.mobile === true) {
          this.$emit("voltar");
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    formatarCpf() {
      const valor = this.cpf.replace(/\D/g, "");
      if (valor.length <= 11) {
        this.cpf = filters.filterCpf(valor);
      }
    },
    voltarEtapa1() {
      this.etapa = 1;
      this.chave = "";
      this.msg = "";
    },
    irParaEtapa2() {
      const cpfLimpo = this.cpf.replace(/\D/g, "");
      if (cpfLimpo.length !== 11) {
        this.msg = "Por favor, informe o CPF antes de continuar.";
        this.msgType = "error";
        return;
      }
      this.msg = "";
      this.msgEmail = "Informe a chave recebida anteriormente.";
      this.etapa = 2;
    },
    async solicitarToken() {
      const cpfLimpo = this.cpf.replace(/\D/g, "");
      if (cpfLimpo.length !== 11) {
        this.msg = "Por favor, informe um CPF válido.";
        this.msgType = "error";
        return;
      }
      this.msg = "";
      this.loading = true;
      try {
        const response = await CredenciamentoServices.solicitacaoTokenMobile(cpfLimpo);
        if (response.success) {
          this.msgEmail = response.data || "Chave enviada para seu e-mail!";
          this.etapa = 2;
        } else {
          this.msg = response.data || response.message || "Não foi possível enviar a chave. Tente novamente.";
          this.msgType = "error";
        }
      } catch {
        this.msg = "Ocorreu um erro ao solicitar a chave. Tente novamente mais tarde.";
        this.msgType = "error";
      } finally {
        this.loading = false;
      }
    },
    async validarChave() {
      if (!this.chave.trim()) {
        this.msg = "Por favor, informe a chave recebida no e-mail.";
        this.msgType = "error";
        return;
      }
      this.msg = "";
      this.loading = true;
      try {
        const cpfLimpo = this.cpf.replace(/\D/g, "");

        const response = await CredenciamentoServices.autenticarTokenMobile(this.chave.trim(), cpfLimpo);
        if (response.success) {
          this.$toast.success(typeof response.success === "string" ? response.success : "Acesso autorizado!");
          this.$router.replace({ name: "homeMain" });
        } else {
          this.msg = response.message || "Chave inválida ou expirada.";
          this.msgType = "error";
        }
      } catch {
        this.msg = "Erro ao validar a chave. Tente novamente.";
        this.msgType = "error";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-card-ajuste {
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  padding: 32px 40px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 800px) {
  .login-card-ajuste {
    padding: 24px 16px !important;
    width: 700px;
  }
}
@media (max-width: 600px) {
  .login-card-ajuste {
    max-width: 98vw;
    padding: 8px !important;
  }
}
.login-card {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  overflow: hidden;
}
.card-header {
  background: linear-gradient(135deg, #ffccbc 0%, #d84315 100%);
  padding: 24px;
  text-align: center;
  position: relative;
  width: 100%;
}
.card-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}
.header-icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-bottom: 16px;
}
.header-title {
  position: relative;
  z-index: 1;
  color: white;
  font-weight: 300;
  margin: 0;
}
.validate-btn {
  border-radius: 8px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}
.voltar-link {
  color: #d84315;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  font-size: 1rem;
  transition: color 0.2s;
}
.voltar-link:hover {
  color: #bcaaa4;
}
</style>
